import React, { useState } from 'react';

type Props = {
    ClosePopup: Function;
    documentUrl: any[];
};

export class TaskDocumentPopup extends React.Component<Props>
{
    constructor(props:any) {
        super(props); 
    }
    state = {
        aUrl: '',
    }

    componentDidMount(){
        const aUrl = localStorage.getItem('apiUrl');
        if (aUrl) {
            this.setState({aUrl: aUrl});
        }
        this.load();
    }

    async load(){
        console.log('LeadDocumentPopup', this.props.documentUrl)
    }

    closePopup = (status?: string)=>{
        this.props.ClosePopup(status);  
    }
    
    render() {
      return ( <>
        <div className="popup-wrapper">
            <section className="popup-window new-lead rtl">
                <div className="close-icon pointer" onClick={(e:any)=>this.closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                        </div>
                    </div>
                    {this.props.documentUrl.length > 0 &&
                            <div className="popup-body" style={{ overflowY: 'auto', maxHeight: '80vh' }}>
                        {this.props.documentUrl.map((item:any, index:number) => {
                            return (
                                <iframe key={index} src={this.state.aUrl+item.filePath} style={{width:'100%',height:'100%'}}></iframe>
                            )
                            }
                        )}
                        </div>
                    }
                    
                    <div className="popup-footer">
                        <button className="button white blue-border"  onClick={(e:any)=>this.closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>
      </>  
        
      );
    }
  }